import { render, staticRenderFns } from "./DocumentTemplateUpdate.vue?vue&type=template&id=e9812996"
import script from "./DocumentTemplateUpdate.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports